export const IS_SPRINTS_ENABLED = 'IS_SPRINTS_ENABLED' as const;
export const IS_POLLING_ENABLED = 'IS_POLLING_ENABLED' as const;
export const IS_CARD_MEDIA_SWITCH_ENABLED = 'IS_CARD_MEDIA_SWITCH_ENABLED' as const;
